(() => {
  function updateShoutoutCopy() {
    document.querySelectorAll('[data-vyora-optin]').forEach(panel => {
      const note = panel.querySelector('small');
      const message = 'Choose Yes and enter your TikTok username to join the Alinta podium after your order is paid. Your points determine your place.';
      if (note && note.textContent !== message) note.textContent = message;
      const input = panel.querySelector('[data-vyora-handle]');
      if (input) {
        const label = panel.querySelector('label[for="' + input.id + '"]');
        if (label && label.textContent !== 'Your TikTok name / @username') label.textContent = 'Your TikTok name / @username';
        input.placeholder = '@your_username';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateShoutoutCopy);
  else updateShoutoutCopy();
  const observer = new MutationObserver(updateShoutoutCopy);
  observer.observe(document.documentElement, {childList:true, subtree:true});
})();